import { PageHeading } from "@peer-start/ui";
import { useTranslation } from "react-i18next";
import { useAppContext } from "../../../app/use-app-context.js";
import { ManagerActiveTrend } from "../components/ManagerActiveTrend.js";
import { ManagerCourseTop } from "../components/ManagerCourseTop.js";
import { ManagerDomainBreakdown } from "../components/ManagerDomainBreakdown.js";
import { ManagerUsageMetrics } from "../components/ManagerUsageMetrics.js";

export function ManagerDashboardPage() {
  const { t } = useTranslation();
  const { persona } = useAppContext();
  if (persona.kind === "employee") return null;

  return (
    <>
      <PageHeading title={t("managerDashboard.title")} />
      <ManagerUsageMetrics />
      <ManagerActiveTrend />
      <div className="mt-4 grid gap-4 xl:grid-cols-2">
        <ManagerCourseTop />
        <ManagerDomainBreakdown />
      </div>
    </>
  );
}
